import { DataproviderServerType } from '../Components/BasicTypes';

export function isInternalProvider(provider: DataproviderServerType) {
  return provider.Uid === '00000000-0000-0000-0000-00000001D570' || provider.Uid === '00000000-0000-0000-0000-00000001D571'
    || provider.Uid === '00000000-0000-0000-0000-00000001D572';
}

export function isGenericDataProvider(provider: DataproviderServerType) {
  return provider.Uid === 'GenericDataProvider';
}

export const LesionTrackingProviderId = 'SectraLesionTracking';
export const FindingsProviderId = 'SectraFindings';